<!--客户联系人信息-->
<template>
    <div class="order-infoTab-section">
        <div class="order-hd">
            <a v-if="Acs('/contacts/create')" @click="createContact()">+新增联系人</a>
        </div>
        <div class="order-bd" v-loading="loading">
            <el-row :gutter="20">
                <el-col v-for="(contact,index) in contacts" :key="index" :span="8" style="margin-top: 20px;">
                    <el-card class="box-card" shadow="hover">
                        <div slot="header" class="clearfix">
                            <span>{{contact.name}}</span><span v-if="contact.status==1" style="color: red">（关键）</span>
                            <el-button style="float: right; padding: 3px 0; color: red;  margin-left:10px;" type="text"
                                       @click="handleDelete(contact.id)" v-if="Acs('/contacts/delete')">删除
                            </el-button>
                            <el-button style="float: right; padding: 3px 0;" type="text"
                                       @click="updateContact(contact)">编辑
                            </el-button>
                        </div>
                        <div class="contact-info">
                            <el-row class="info-item"><label>职务：</label> {{contact.job_name}}</el-row>
                            <el-row class="info-item"><label>手机：</label> {{contact.mobile}}</el-row>
                            <el-row class="info-item"><label>电话号码：</label> {{contact.phone_number}}</el-row>
                            <el-row class="info-item"><label>QQ：</label> {{contact.qq == '' ? '暂无' : contact.qq }}
                            </el-row>
                            <el-row class="info-item"><label>创建时间：</label> {{contact.created_at}}</el-row>
                        </div>
                    </el-card>
                </el-col>
            </el-row>
        </div>

        <!--新增联系人与编辑联系人的对话框-->
        <contact-form v-if="showForm"
                      :customerId="customerId"
                      :contactId="contactId"
                      :isShowCustomerName="true"
                      :isUpdateCustomerName="false"
                      :customerName="customerName"
                      @changeShow="changeShow"
                      @changeCreate="changeCreate"
                      @changeUpdate="changeUpdate"
        ></contact-form>

        <el-row v-if="linkPage">
            <pagination :linkPage="linkPage" :enableEvent="true" @change="watchPageChange"></pagination>
        </el-row>

    </div>
</template>

<script>
    import ContactService from "~/services/contact";
    import CommonService from "~/services/common";
    import ContactForm from "~/views/contact/form.vue";
    import Pagination from "~/widgets/Pagination.vue";

    export default {
        name: "CustomerContacts",

        components: {
            //联系人新增与编辑表单
            ContactForm,
            Pagination
        },

        props: {
            customerId: {
                type: Number,
                default: 0,
                required: true
            },
            customerName: ''
        },
        data() {
            return {
                loading: true,
                contacts: [],
                showForm: false,//是否展示Dialog对话框
                contactId: "",
                customer_name: '',
                // 分页信息
                linkPage: null,
            };
        },
        watch: {
            customerId: function (value, original) {
                this.getContacts({customer_id: value});
            },
        },
        created: function () {
            if (this.contacts.length < 1 && this.customerId > 0) {
                this.getContacts({customer_id: this.customerId});
            }
        },
        methods: {
            getContacts(params) {
                CommonService.getContacts(params).then(res => {
                    this.loading = false;
                    if (res && res.data) {
                        this.contacts = res.data;
                        if (res._meta) {
                            this.linkPage = res._meta;
                        }
                    }
                }).catch(err => {
                    this.loading = false;
                    console.error(err);
                })

            },

            /**
             * 监听分页改变事件
             * @param pageParams
             */
            watchPageChange(pageParams) {
                this.getContacts({
                    customer_id: this.customerId,
                    page: pageParams["page"],
                    perPage: pageParams["perPage"]
                });
            },

            //新增联系人，展示Dialog对话框
            createContact() {
                this.showForm = true;
                this.contactId = '';
                // this.customeId = this.customerId;
            },

            //修改联系人，展示Dialog对话框
            updateContact(contact) {
                this.showForm = true;
                this.contactId = contact.id;
            },

            //form dialog 的回调 start

            //关闭dialog窗口更新showForm值
            changeShow(isShow) {
                this.showForm = isShow;
            },

            //新增后列表中增加展示新数据
            changeCreate(contact) {
                // this.contacts.unshift(contact);
                this.getContacts({customer_id: this.customerId});
            },

            //编辑后列表数据立即更新
            changeUpdate(obj) {
                // let form = obj.form;
                // let index = this.contacts.findIndex(function(item) {
                //     return item.id == form.id;
                // });
                // this.contacts = [
                //     ...this.contacts.slice(0, index),
                //     obj.contact,
                //     ...this.contacts.slice(index + 1)
                // ];
                // this.contacts = this.contacts.map(item => {
                //     if (item.id == form.id) return obj.contact;
                //     return item;
                // });
                this.getContacts({customer_id: this.customerId});
            },
            //form dialog 的回调 end

            handleDelete(contactId) {
                let _this = this;
                _this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    ContactService.delete(contactId).then(res => {
                        if (res.code == 0) {
                            this.$message({
                                type: 'success',
                                message: '删除成功!'
                            });
                            _this.contacts = _this.contacts.filter(contact => {
                                return contactId != contact.id;
                            });
                        }
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            }
        },
    }
</script>


// WEBPACK FOOTER //
// src/views/customer/Contacts.vue